import { useEffect, useCallback } from 'react';
import { shell } from '@frontend/shell-utils';

const notificationPendoId = 'notifications-pendo-handler';
import { pendo } from '@frontend/tracking';
import { WeavePopNotification } from '@frontend/types';

const pendoKeys = {
  clearAll: 'pendo-notifications-clear-all',
  expand: 'pendo-notifications-expand',
  collapse: 'pendo-notifications-collapse',
  dismiss: 'pendo-notifications-dismiss',
  view: 'pendo-notifications-view',
  respond: 'pendo-notifications-respond',
};

export const useNotificationsShellPendo = () => {
  const handlePendoNotification = useCallback(
    (
      _e: any,
      notification: {
        action: 'clear-all' | 'expand' | 'collapse' | 'dismiss' | 'view' | 'respond';
        notificationType?: WeavePopNotification['type'];
      }
    ) => {
      if (notification.action === 'clear-all') {
        pendo.track(pendoKeys.clearAll);
      }

      if (notification.action === 'expand') {
        pendo.track(pendoKeys.expand);
      }
      if (notification.action === 'collapse') {
        pendo.track(pendoKeys.collapse);
      }
      if (notification.action === 'dismiss') {
        pendo.track(pendoKeys.dismiss, {
          notificationType: notification?.notificationType || 'unknown',
        });
      }
      if (notification.action === 'view') {
        pendo.track(pendoKeys.view, {
          notificationType: notification?.notificationType || 'unknown',
        });
      }

      if (notification.action === 'respond') {
        pendo.track(pendoKeys.view, {
          notificationType: notification?.notificationType || 'unknown',
        });
      }
    },
    []
  );

  useEffect(() => {
    if (shell?.isShell) {
      shell?.on?.('notifications:pendo', handlePendoNotification, notificationPendoId);
    }
    return () => {
      if (shell?.isShell) {
        shell?.off?.('notifications:pendo', handlePendoNotification, notificationPendoId);
      }
    };
  }, [handlePendoNotification]);
};
